import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import des traductions directement (alternative au backend HTTP)
import commonFr from './locales/fr/common.json';
import authFr from './locales/fr/auth.json';
import dashboardFr from './locales/fr/dashboard.json';
import legalFr from './locales/fr/legal.json';
import landingFr from './locales/fr/landing.json';
import galeneKeysFr from './locales/fr/galeneKeys.json';
import guidesFr from './locales/fr/guides.json';

import commonEn from './locales/en/common.json';
import authEn from './locales/en/auth.json';
import dashboardEn from './locales/en/dashboard.json';
import legalEn from './locales/en/legal.json';
import landingEn from './locales/en/landing.json';
import galeneKeysEn from './locales/en/galeneKeys.json';
import guidesEn from './locales/en/guides.json';

const resources = {
  fr: {
    common: commonFr,
    auth: authFr,
    dashboard: dashboardFr,
    legal: legalFr,
    landing: landingFr,
    galeneKeys: galeneKeysFr,
    guides: guidesFr
  },
  en: {
    common: commonEn,
    auth: authEn,
    dashboard: dashboardEn,
    legal: legalEn,
    landing: landingEn,
    galeneKeys: galeneKeysEn,
    guides: guidesEn
  }
};

i18n
  // Détection de la langue du navigateur
  .use(LanguageDetector)
  // Intégration avec React
  .use(initReactI18next)
  // Initialisation
  .init({
    resources,
    fallbackLng: 'fr', // Langue par défaut
    defaultNS: 'common', // Namespace par défaut
    ns: ['common', 'auth', 'dashboard', 'legal', 'landing', 'galeneKeys', 'guides'], // Namespaces disponibles
    
    // Détection de la langue
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    
    // Interpolation
    interpolation: {
      escapeValue: false, // React échappe déjà les valeurs
    },
    
    // Debug en développement uniquement
    debug: false, // Désactivé pour éviter le spam en console
    
    // Comportement
    react: {
      useSuspense: true, // ✅ Activé pour attendre le chargement des traductions
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '', // Valeur pour les nœuds vides
      transSupportBasicHtmlNodes: true, // Support HTML basique
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'], // Nœuds HTML autorisés
    },
    
    // Ajouter des fallbacks robustes
    saveMissing: false,
    missingKeyHandler: (lng, ns, key) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Missing translation key: [${ns}] ${key} for language: ${lng}`);
      }
    },
    
    // Parsing des pluriels
    parseMissingKeyHandler: (key) => {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Missing key parsed: ${key}`);
      }
      return key;
    },
  });

export default i18n;

